export const handleQuoteModal = (dispatch, isOpen, previousHomeExcess, previousContentsExcess, hasActiveFilter) => {
    dispatch({
        type: 'SET_RESULTS_CONFIG_VALUE',
        key: 'helpers.updateQuoteModal',
        value: { open: isOpen }
    });
    if (!isOpen && hasActiveFilter) {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'filters.showFiltersUpdateButton',
            value: true
        });
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'filters.homeExcess',
            value: previousHomeExcess
        });
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'filters.contentsExcess',
            value: previousContentsExcess
        });
        // reset cover detail values
        dispatch({
            type: 'SET_VALUE',
            identifier: 'excessDetails.homeExcess',
            stateKey: 'vertical.quote',
            value: previousHomeExcess
        });
        dispatch({
            type: 'SET_VALUE',
            identifier: 'excessDetails.contentsExcess',
            stateKey: 'vertical.quote',
            value: previousContentsExcess
        });
        // add filter actions to results config filters currentFilterActions
        dispatch({
            type: 'SET_FILTER_ACTION',
            resultsStateKey: 'filters.homeExcess',
            resultsStagedStateKey: 'helpers.filters.homeExcess',
            formStateKey: 'form.excessDetails.homeExcess'
        });
        dispatch({
            type: 'SET_FILTER_ACTION',
            resultsStateKey: 'filters.contentsExcess',
            resultsStagedStateKey: 'helpers.filters.contentsExcess',
            formStateKey: 'form.excessDetails.contentsExcess'
        });
    }
};
